import React from 'react';
import { Button } from 'primereact/button';

import './NotFound.scss';

const NotFound = () => {
  return (
    <div className="not-found">
      <div className="container">
        <h1 className="mb-5">404 - Page Not Available</h1>
        <p className="mb-5">
          The page you&apos;re seeking is not available. If you followed a link provided by a reseller, the URL may be incorrect
          or outdated. Please verify the link or contact your reseller.
        </p>
        <p className="mb-5">For assistance or to discover more about our services, visit the UPshow homepage.</p>
        <div className="buttons-container">
          <a href="https://www.upshow.tv/">
            <Button label="Go to UPshow Homepage" className="p-button btn-magenta" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
